import React from 'react'
import { createRoot } from 'react-dom/client'
import WelcomeCouponMount from 'components/TeamPublicPage/WelcomeCouponMount'

// Mounts the welcome-coupon prompt on the community pages. Called from BOTH
// community entries (community-page.js for index, community-post-interactions.js
// for show) because application_helper maps the two actions to different entries.
// Isolated in try/catch + early-return so a missing/malformed payload can never
// break the rest of the entry's logic.
export function mountWelcomeCoupon() {
  const el = document.getElementById('welcome-coupon-mount')
  if (!el || el.dataset.mounted) return
  el.dataset.mounted = '1'

  try {
    const props = JSON.parse(el.dataset.props)
    createRoot(el).render(
      <WelcomeCouponMount
        team={props.team}
        currentUser={props.currentUser}
        teamSlug={props.teamSlug}
        translations={props.translations}
        brandColor={props.brandColor}
        welcomeCouponClaimable={props.welcomeCouponClaimable}
      />
    )
  } catch (e) {
    // Bad payload must not break community post rendering / social proof.
    console.error('Failed to mount welcome coupon:', e)
  }
}
